import z from 'zod';
import {ApiDefinition} from '../definitions';
import {ObjectIdSchema} from '../../zod';
import {Roles} from '../../user';
import {KeyplayUserSchema} from '../../auth';

export const CompleteOnboarding = {
  path: 'customer/onboarding',
  method: 'post',
  options: {access: 'all'},
  requestDataSchema: z.object({}),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const Logout = {
  path: 'customer/logout',
  method: 'post',
  options: {access: 'all'},
  requestDataSchema: z.object({}),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const UpdateWebsite = {
  path: 'customer/updateWebsite',
  method: 'post',
  options: {access: 'all'},
  requestDataSchema: z.object({
    domain: z.string(),
    accountId: ObjectIdSchema.optional(),
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const GetUser = {
  path: 'customer/user',
  method: 'get',
  options: {access: 'all'},
  requestDataSchema: z.object({}),
  responseDataSchema: z.object({intercomHash: z.string()}),
} satisfies ApiDefinition;

export const UpdateUserRole = {
  path: 'customer/user',
  method: 'post',
  options: {access: 'all'},
  requestDataSchema: z.object({
    role: z.enum(Roles),
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const GetUsers = {
  path: 'customer/users',
  method: 'get',
  options: {access: 'all'},
  requestDataSchema: z.object({}),
  responseDataSchema: z.object({users: KeyplayUserSchema.array()}),
} satisfies ApiDefinition;

export const InviteUser = {
  path: 'customer/invite',
  method: 'post',
  options: {access: 'all'},
  requestDataSchema: z.object({
    email: z.string().email(),
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;
